import ShopSales from "lib/games/ShopSales";
const SelectorUtility = require("lib/shared/SelectorUtility");

export const getPatches = ({ state, filters, conditions }) =>
	SelectorUtility.filterBy(state.patches, filters, conditions);

export const getFilteredPatches = ({ state }) =>
	_.select(
		getPatches({ state }),
		patch =>
			patch.owned ||
			patch.source == "default" ||
			patch.source == "store" ||
			ShopSales.isOnSale(patch.origin_patch_type, patch.name),
	);

export const getPatchesByNameAndType = ({ state, name, originType }) => {
	const r = _.select(
		getFilteredPatches({ state }),
		patch => patch.name == name && patch.origin_patch_type == originType,
	);
	return r;
};

export const getPerks = ({ state, filters, conditions }) =>
	SelectorUtility.filterBy(state.perks, filters, conditions);

export const getFilteredPerks = ({ state }) =>
	_.select(getPerks({ state }), perk => {
		return perk.owned || perk.source == "default" || perk.source == "store";
	});

export const getPerksByNameAndType = ({ state, name, type }) => {
	const r = _.select(
		getFilteredPerks({ state }),
		perk => perk.name == name && perk.perk_type == type,
	);
	return r;
};
export const getFurnitures = ({ state, filters, conditions }) =>
	SelectorUtility.filterBy(state.furnitures, filters, conditions);

export function photographs({ state, filters, conditions }) {
	return SelectorUtility.filterBy(state.photographs, filters, conditions);		
}

export function photograph({ state, id }) {
	return state.photographs[id];
}

export function isLoadingPhotographs({ state, key }) {
	key = key || "index";
	return state.photographs.loading[key];
}




// WEBPACK FOOTER //
// ./modules/lib/selectors/OwlShopSelectors.js